module.exports = __webpack_public_path__ + "static/media/SF-Pro-Text-Regular.404e4373.otf";